import React, { useState, createContext } from "react";


export const LanguageContext = createContext();

export default function ErrorProvider(props) {
    
  const [language,setLanguage]=useState('en');
  const [isEs,setIsEs]=useState(false);
  const { children } = props;

  const data ={
    language,
    setLanguage,
    isEs,
    setIsEs
  }

  return <LanguageContext.Provider value={data}>{children}</LanguageContext.Provider>;
}
